import { riperStorage } from '@/base/helpers';

const Flow = {
  _keys: {
    program_page_redirect: 'liana_clicked_auth_button',
  },
  redirectOnAuthToProgramPage(onAuth) {
    localStorage.setItem(Flow._keys.program_page_redirect, '1');
    onAuth();
  },
  init(account) {
    if (account && localStorage.getItem(Flow._keys.program_page_redirect)) {
      localStorage.removeItem(Flow._keys.program_page_redirect);
      riperStorage.onAbout();
    }
  },
};

export default Flow;
